import { DEMO_DATA_BASE } from "@/demo/demo";
import { TOKEN_KEY, USER_KEY } from "@/lib/auth";

// The demo viewer is always signed in. The token is a placeholder; the demo adapter never sends it anywhere.
const FALLBACK_USER = { username: "demo", name: "Demo viewer", role: "tpi_inspector" };

export async function seedDemoSession() {
  let user = FALLBACK_USER;
  try {
    user = await fetch(`${DEMO_DATA_BASE}/user.json`).then((r) => (r.ok ? r.json() : FALLBACK_USER));
  } catch (_) { /* keep fallback */ }
  try {
    sessionStorage.setItem(TOKEN_KEY, "demo");
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch (_) { /* storage blocked: the app falls back to /login, which the demo build redirects away from */ }
}
